import React, { useEffect, useRef, useState } from "react";

import { Card, Col, Nav, Row } from "react-bootstrap";
import BtnGroup from "../../baseui/buttons/BtnGroup";
import { Icon } from "@iconify/react";
import TableSurveyList from "../../dashboardHome/TableSurveyList";
import SearchField from "../../layouts/SearchField";
import { Link } from "react-router-dom";
import User from "../../../assets/images/user.png";
import { format } from "date-fns";
import {
  clientSelector,
  getClients,
  resetClient,
} from "../../../redux/clientSlice";
import { useDispatch, useSelector } from "react-redux";
import { openClientModal } from "../../../redux/modalSlice";
import Dropdown from "react-bootstrap/Dropdown";
import { getSurveyors, surveyorSelector } from "../../../redux/userSlice";
import {
  assignSurveys,
  getAllSurveys,
  pageSelector,
  requestReports,
  surveysSelector,
  updateAllSurveys,
  updateStatus,
  viewClientIsActive,
  setClientIsActive,
  deleteSurveys,
  pageSizeSelector,
} from "../../../redux/surveySlice";

import { error, success } from "../../../redux/notificationSlice";
import { api } from "../../../services/api-service";
import { pascalCase } from "pascal-case";
import DeleteSurvey from "./DeleteSurvey";
import fileDownload from "js-file-download";
import axios from "axios";
import InspectionDateFilter from "../../layouts/InspectionDateFilter";

const SurveyCard = ({ survey, text, setSearchText, getSurveys }) => {
  const dispatch = useDispatch();
  const searchTimeout = useRef();
  const surveyorTimeout = useRef();
  const { allClients } = useSelector(clientSelector);
  const surveyors = useSelector(surveyorSelector);
  const surveys = useSelector(surveysSelector);
  const page = useSelector(pageSelector);
  const pageSize = useSelector(pageSizeSelector);
  const isActive = useSelector(viewClientIsActive);
  const [search, setSearch] = useState("");
  const [searchSurveyor, setSearchSurveyor] = useState("");
  const [selected, setSelected] = useState("");
  const [surveyor, setSurveyor] = useState("");
  const [status, setStatus] = useState("");
  const [show, setShow] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    if (surveyorTimeout.current) {
      clearTimeout(surveyorTimeout.current);
    }

    surveyorTimeout.current = setTimeout(() => {
      getAllClients(1);
    }, 500);
  }, [search]);

  useEffect(() => {
    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    searchTimeout.current = setTimeout(() => {
      getAllSurveyors();
    }, 500);
  }, [searchSurveyor]);

  useEffect(() => {
    if (survey?.data?.filter((sur) => sur.checked).length > 0) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, [surveys]);

  const getAllClients = (pageNum) => {
    dispatch(
      getClients({ pageNum: pageNum, searchText: search, pageSize: pageSize })
    );
  };

  const getAllSurveyors = () => {
    dispatch(getSurveyors({ pageNum: 1, searchText: searchSurveyor }));
  };

  const getStartDateFilter = () =>
    startDate ? format(startDate, "yyyy-MM-dd") : null;

  const getEndDateFilter = () =>
    endDate ? format(endDate, "yyyy-MM-dd") : null;

  const getFilteredSurveys = (requestedPageSize, pageNumber) => {
    getSurveys(
      requestedPageSize,
      pageNumber,
      selected || null,
      status,
      getStartDateFilter(),
      getEndDateFilter(),
    );
  };

  const handleRowClick = (client) => {
    if (client.clientRef === selected) {
      getSurveys(
        pageSize,
        1,
        null,
        status,
        getStartDateFilter(),
        getEndDateFilter(),
      );
      setSelected("");
      return;
    }
    setSelected(client.clientRef);
    getSurveys(
      pageSize,
      1,
      client.clientRef,
      status,
      getStartDateFilter(),
      getEndDateFilter(),
    );
  };

  const handleSubmit = async () => {
    if (!surveyor) {
      dispatch(error("Please select surveyor to assign surveys"));
      return;
    }
    if (
      surveys.data.filter((sur) => sur.checked && sur.status !== "draft")
        .length > 0
    ) {
      dispatch(error("Only draft survey(s) can be assigned to surveyors"));
      return;
    }
    dispatch(
      assignSurveys({
        surveyor,
        surveys: surveys.data.filter((sur) => sur.checked).map((sur) => sur.id),
        clientRef: selected ? selected : null,
        pageNum: page,
        filters: {
          pageSize,
          searchText: text,
          status,
          startDate: getStartDateFilter(),
          endDate: getEndDateFilter(),
        },
      })
    );
  };

  const handleStatusChange = (status) => {
    setStatus(status);
    getSurveys(
      pageSize,
      status ? 1 : page,
      selected,
      status,
      getStartDateFilter(),
      getEndDateFilter(),
    );
  };

  const applyDateFilter = (start, end) => {
    setStartDate(start);
    setEndDate(end);
    getSurveys(
      pageSize,
      1,
      selected,
      status,
      format(start, "yyyy-MM-dd"),
      format(end, "yyyy-MM-dd"),
    );
  };

  const clearDateFilter = () => {
    setStartDate(null);
    setEndDate(null);
    getSurveys(pageSize, 1, selected, status, null, null);
  };

  const handleDeleteSurveys = () => {
    const ids = surveys.data.filter((sur) => sur.checked).map((sur) => sur.id);
    dispatch(
      deleteSurveys({
        surveys: ids,
        clientRef: selected ? selected : null,
        pageNum:
          ids.length === surveys.data.length
            ? page > 1
              ? page - 1
              : page
            : page,
        pageSize,
        filters: {
          pageSize,
          searchText: text,
          status,
          startDate: getStartDateFilter(),
          endDate: getEndDateFilter(),
        },
      })
    );
    setShowDelete(false);
  };

  const handleRequestFiles = async () => {
    if (
      surveys.data.filter((sur) => sur.checked && sur.status === "draft")
        .length > 0
    ) {
      dispatch(
        error("Report(s) cannot be generated as survey is not submitted yet")
      );
      return;
    }
    const ids = surveys.data.filter((sur) => sur.checked).map((sur) => sur.id);
    ids.forEach(async (id) => {
      const response = await api.post(`download-report/${id}`);
      if (response?.ok) {
        axios
          .get(response.data.data, {
            responseType: "blob",
          })
          .then((res) => {
            fileDownload(
              res.data,
              surveys.data.find((sur) => sur.id === id)?.hdcAssetReference +
                ".pdf"
            );
          });
      }
    });
  };

  const handleReset = async () => {
    setShow(false);
    let updatedSurveys = surveys.data.map((sur) => {
      return { ...sur, checked: false };
    });
    dispatch(updateAllSurveys(updatedSurveys));
  };

  const updateSurveyStatus = async (props, nextStatus) => {
    dispatch(
      updateStatus({
        id: props.row.original.id,
        pageNum: props.initialState.pageNumber,
        status: nextStatus,
        clientRef: selected ? selected : null,
        filters: {
          pageSize,
          searchText: text,
          status,
          startDate: getStartDateFilter(),
          endDate: getEndDateFilter(),
        },
      })
    );
  };

  const hideClientViewhandler = () => {
    dispatch(setClientIsActive(false));
  };

  return (
    <>
      <Row>
        <Col xxl="3">
          <Card
            className={
              isActive
                ? "card-main p-0 clientCard active"
                : "card-main p-0 clientCard"
            }
          >
            <div className="card-title d-flex align-items-center pb-0">
              <h5 className="mb-0">
                Clients
                <Link
                  to="#"
                  onClick={() => {
                    dispatch(resetClient());
                    dispatch(openClientModal());
                  }}
                  className="ctaAdd"
                >
                  <svg
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8 3.1665L8 13.8332"
                      stroke="white"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M13.3333 8.5L2.66663 8.5"
                      stroke="white"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </Link>
              </h5>
              <button
                className="btn btn-close p-0 ms-auto d-xxl-none d-inline-flex"
                onClick={hideClientViewhandler}
              >
                <Icon icon="ri:close-fill" width="16" height="16" />
              </button>
            </div>
            <div className="card-body pt-2">
              <div className="filterSearch mb-3">
                <SearchField text={search} onChange={(e) => setSearch(e)} />
                {/*   <Nav className="justify-content-end cta_square ms-2">
                  <Nav.Item>
                    <Nav.Link>
                      <Icon icon="iconoir:filter" />
                    </Nav.Link>
                  </Nav.Item>
                </Nav>*/}
              </div>
              <div className="clientRef">
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Ref</th>
                        <th>Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      {allClients.data &&
                        allClients.data.map((client) => (
                          <tr
                            key={client.id}
                            className={
                              selected === client.clientRef ? "active" : ""
                            }
                            onClick={() => handleRowClick(client)}
                          >
                            <td>{client.clientRef}</td>
                            <td>{client.name}</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </Card>
        </Col>

        <Col xxl="9">
          <Card className="card-main p-0 ">
            <Card.Title className="row mb-3 align-items-center">
              <div className="col-lg-3">
                <h5 className="mb-0">List of surveys</h5>
              </div>
              <div className="col-lg-9">
                {show ? (
                  <div className="filterUser">
                    <Dropdown>
                      <Dropdown.Toggle variant="searchUser" id="dropdown-basic">
                        {surveyor ? (
                          <>
                            <div className="avatar">
                              {surveyor?.firstName?.charAt(0).toUpperCase() +
                                surveyor?.lastName?.charAt(0).toUpperCase()}
                            </div>
                            <div className="user">
                              {surveyor?.firstName + " " + surveyor?.lastName}
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="user">Select Surveyor</div>
                          </>
                        )}
                        <i>
                          <Icon icon="material-symbols:keyboard-arrow-down-rounded" />
                        </i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <form
                          className="formSearch"
                          onSubmit={(e) => e.preventDefault()}
                        >
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search"
                            value={searchSurveyor}
                            onChange={(e) => setSearchSurveyor(e.target.value)}
                          />
                          <i>
                            <svg
                              width="18"
                              height="19"
                              viewBox="0 0 18 19"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="8.82491"
                                cy="9.32491"
                                r="6.74142"
                                stroke="#006666"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M13.5137 14.3638L16.1567 16.9999"
                                stroke="#006666"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </i>
                        </form>
                        <ul className="listUser">
                          {surveyors.data &&
                            surveyors.data.map((surveyor) => (
                              <li onClick={() => setSurveyor(surveyor)}>
                                <Dropdown.Item href="#" className="media">
                                  <div className="avatar">
                                    {surveyor?.firstName
                                      .charAt(0)
                                      .toUpperCase() +
                                      surveyor?.lastName
                                        .charAt(0)
                                        .toUpperCase()}
                                  </div>
                                  <div className="media-body">
                                    {surveyor.firstName +
                                      " " +
                                      surveyor.lastName}
                                  </div>
                                </Dropdown.Item>
                              </li>
                            ))}
                        </ul>
                      </Dropdown.Menu>
                    </Dropdown>
                    <ul>
                      <li>
                        <button
                          className="btn cta-primary"
                          onClick={() => handleSubmit()}
                        >
                          Assign
                        </button>
                        <button
                          className="btn cta-primary"
                          onClick={() => setShowDelete(true)}
                        >
                          Delete
                        </button>
                        <button
                          className="btn cta-primary"
                          onClick={() => handleRequestFiles()}
                        >
                          Download Report(s)
                        </button>
                      </li>
                      <li>
                        <button
                          className="btn cta-primary-light"
                          onClick={() => handleReset()}
                        >
                          Discard
                        </button>
                      </li>
                    </ul>
                  </div>
                ) : (
                  <>
                    <div className="filterForm">
                      <div className="filterMain">
                        <Dropdown>
                          <Dropdown.Toggle
                            variant="searchUser"
                            id="dropdown-basic"
                          >
                            {status ? pascalCase(status) : "Filter by status"}

                            {status && (
                              <i>
                                <Icon
                                  icon="radix-icons:cross-1"
                                  onClick={() => handleStatusChange()}
                                />
                              </i>
                            )}
                            <i>
                              <Icon icon="material-symbols:keyboard-arrow-down-rounded" />
                            </i>
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <h4>Filter by</h4>
                            <ul>
                              <li onClick={() => handleStatusChange("draft")}>
                                <Dropdown.Item href="#">Draft</Dropdown.Item>
                              </li>
                              <li
                                onClick={() => handleStatusChange("accepted")}
                              >
                                <Dropdown.Item href="#">Accepted</Dropdown.Item>
                              </li>
                              <li
                                onClick={() => handleStatusChange("submitted")}
                              >
                                <Dropdown.Item href="#">
                                  Submitted
                                </Dropdown.Item>
                              </li>
                              <li
                                onClick={() => handleStatusChange("published")}
                              >
                                <Dropdown.Item href="#">
                                  Published
                                </Dropdown.Item>
                              </li>
                            </ul>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                      <SearchField onChange={setSearchText} text={text} />
                      <InspectionDateFilter
                        startDate={startDate}
                        endDate={endDate}
                        onApply={applyDateFilter}
                        onClear={clearDateFilter}
                      />
                    </div>
                  </>
                )}
              </div>
            </Card.Title>
            <Card.Body>
              <div className="surveyList">
                <TableSurveyList
                  getSurveys={getFilteredSurveys}
                  survey={survey}
                  searchText={text}
                  statusUpdate={updateSurveyStatus}
                  isFiltered={Boolean(
                    selected || status || startDate || endDate,
                  )}
                />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <DeleteSurvey
        show={showDelete}
        onHide={() => setShowDelete(false)}
        onRemove={handleDeleteSurveys}
      />
    </>
  );
};

export default SurveyCard;
